<ng-container *ngIf="this.externalSettings == null">Loading...</ng-container>

<ng-container *ngIf="this.externalSettings != null">
  <header *ngIf="externalLoaded | async">
    <div class="container">
      <nav class="header-nav py-2">
        <div>

          <a class="navbar-brand cursor-pointer" (click)="onLogoClick()">
            <img [src]="src" width="240" alt="Logo" />
          </a>

          <span *ngIf="!environment.production" [ngStyle]="UIUtilityService.getHeaderStyle(this.externalSettings)">
            <button mat-button (click)="onInfoClick()">{{ this.getVersion() }} - {{ this.externalSettings.templates}} </button>
          </span> 
          
        </div>
        <app-login-control></app-login-control>
      </nav>
    </div>
    <app-user-header *ngIf="(internalLoaded | async) && menuType == 'left'"></app-user-header>
  </header>
</ng-container>